// isDownloadOk accepts the two success statuses a content download can
// return. A plain object answers 200. Content stored as a multipart/tr-parts
// container is fetched with a Range header for the uploaded document
// (tech-designs/multipart-content.md), which S3 answers with 206.
export function isDownloadOk(response: Response | undefined): boolean {
  return !!response && (response.status === 200 || response.status === 206)
}

// decodeTextBody turns downloaded text bytes into a string by their
// byte-order mark, falling back to UTF-8. fetch's response.text() always
// decodes as UTF-8, which garbles the UTF-16 HTML and text files Windows
// tools export.
export function decodeTextBody(bytes: Uint8Array): string {
  const [b0, b1, b2] = [bytes[0], bytes[1], bytes[2]]
  if (b0 === 0xff && b1 === 0xfe) {
    return new TextDecoder('utf-16le').decode(bytes.subarray(2))
  }
  if (b0 === 0xfe && b1 === 0xff) {
    return new TextDecoder('utf-16be').decode(bytes.subarray(2))
  }
  if (b0 === 0xef && b1 === 0xbb && b2 === 0xbf) {
    return new TextDecoder('utf-8').decode(bytes.subarray(3))
  }
  return new TextDecoder('utf-8').decode(bytes)
}
